var CACHE_SENTINEL = new Object(); // jshint ignore:line

module.service('ModelConfig', function($http, $q, ApiUrl, LabeledArray) {
    var url = ApiUrl.partial('system'),
        service = this,
        modelMap = {},
        usStatesRaw, usStatesLabeledArray,
        data, promise;

    this.resolve = function() {
        if(data) { return $q.when(data); }
        if (promise) { return promise; }
        promise = $http.get(url('datapoints')).then(function(response) {
            var model, datapoint;
            data = response.data.item;
            for (model in data) {
                for (datapoint in data[model]) {
                    modelMap[datapoint] = modelMap[datapoint] || [];
                    modelMap[datapoint].push(model);
                    if (data[model][datapoint].options.length > 0) {
                        data[model][datapoint].options = new LabeledArray(data[model][datapoint].options);
                    }

                }
            }
            return data;
        });
        return promise;
    };

    this.getDatapoint = addArrayArgument(function(name, model) {
        if (!modelMap[name]) {
            throw new TypeError('No such datapoint ' + name);
        }
        if (!model && modelMap[name].length !== 1) {
            console.log(modelMap[name]);
            throw new TypeError('Must specify model name for datapoint ' + name);
        }
        model = model || modelMap[name][0];
        return data[model][name];
    })

    this.getOptions = addArrayArgument(function(name, model) {
        var datapoint = this.getDatapoint(name, model);
        if (!(datapoint.options instanceof LabeledArray)) {
            datapoint.options = new LabeledArray(datapoint.options);
        }

        return datapoint.options;
    });

    this.getDatapointNames = function(modelName) {
        return Object.keys(data[modelName]);
    };

    this.getModelDatapoints = function(modelName) {
        return this.getDatapoint(this.getDatapointNames(modelName), modelName);
    };

    this.getLabel = addArrayArgument(function(name, model) {
        return service.getDatapoint(name, model).label;
    });

    this.getQuestion = addArrayArgument(function(name, model) {
        return service.getDatapoint(name, model).question;
    });

    this.getHelpText = addArrayArgument(function(name, model) {
        return service.getDatapoint(name, model).help_text;
    });

    this.hasHelpText = addArrayArgument(function(name, model) {
        return !!service.getDatapoint(name, model).help_text;
    });

    this.getUsStates = function(useArray) {
        var promise;
        if (usStatesRaw) {
            promise = $q.when(usStatesRaw);
        } else {
            promise = $http.get(ApiUrl('state')).then(function(response) {
                var asArray = [], i;
                usStatesRaw = response.data.items;

                for (i = 0; i < usStatesRaw.length; i++) {
                    asArray.push([usStatesRaw[i].abbreviation, usStatesRaw[i].name])
                }
                usStatesLabeledArray = new LabeledArray(asArray);

                return usStatesRaw;
            });
        }

        if (useArray) {
            return promise.then(function() { return usStatesLabeledArray; })
        } else {
            return promise;
        }
    };

});


function addArrayArgument(fn) {
    return function(names, model) {
        var self = this;
        if (angular.isArray(names)) {
            return names.reduce(function(obj, name) {
                obj[name] = fn.call(self, name, model);
                return obj;
            }, {});
        } else {
            return fn.call(self, names, model);
        }
    }
}
